import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import CheckoutButton from '../components/CheckoutButton';
import { isAlternativeHeader } from '../utils';

export default connect(
  state => ({
    basket: state.basket,
    isAlternativeHeader: isAlternativeHeader(state.user.betaFeatures),
  })
)(withRouter(CheckoutButton));
